module.exports = __webpack_public_path__ + "img/brush-HONEY.95b39456.png";